<template>
  <router-view />
</template>
<script>
export default { name: 'Attributes' }
</script>
